module.exports = __webpack_public_path__ + "static/media/feedback.3180d55e.png";